import utils from '@/js/utils';
import MENU_PERFORMANCE_EVALUATION from '@/configs/menus/performance_evaluation.menu';
export default [{
  path: '/performance-evaluation/evaluation',
  name: 'performance_evaluation',
  component: function component() {
    return import(/* webpackChunkName: "apps-performance-evaluation" */'@/apps/performance-evaluation/pages/EvaluationPage.vue');
  },
  meta: {
    authentified: utils.getPermissiosInMenuDict('performance_evaluation', MENU_PERFORMANCE_EVALUATION)
  }
}];